import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getData, putData } from '../Services/api'

const ContactTypeEdit = () => {
    const { id } = useParams();
    const [values, setValues] = useState({ name: "" });

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    }

    const fetchRoutes = async () => {
        try {
            const res = await getData(`/contacttypes/${id}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch contacttypes details", error)
        }
    }

    useEffect(() => {
        fetchRoutes();
    }, [id])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {

            const res = await putData(`/contacttypes/update/${id}`, values);
            if (res.status) {
                toast.success(res.message || 'Route updated successfully');
                navigate('/contacttypes/contacttype-list');
                setValues({ name: "" })
            } else {
                toast.error(res.message)
            }
        } catch (error) {
            console.log("error Contact Type update", error)
            toast.error(error.response.data.message || 'error')
        } finally {
            setLoading(false)
        }
    }
    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/contacttypes/contacttype-list">Contact Type</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Edit Contact Type
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Edit Contact Type</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Edit Contact Type</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Contact Type Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter name"
                                                        name='name'
                                                        value={values.name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <Link to="/routes/route-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactTypeEdit
